import type { IDTEFPaymentItem } from "@/@types/dtef-payment"
import { format } from "date-fns"

export const formatDateToBR = (date: string | undefined): string => {
  if (!date) return ""
  try {
    return format(new Date(date), "dd/MM/yyyy")
  } catch {
    return ""
  }
}

export interface ITefCard {
  bandeira: string
  redeAdquirente: string
  quantidade: number
  valorTotal: string
}

export const INVALID_BRANDS = ["DESCONHECIDA", "DESFEITA", "UNKNOWN", ""]
export const SOFTWAY_AUTHORIZATION = "SOFTWAY"
export const TYPE_FATURA_AVENIDA = "Fatura Avenida DTEF"
export const TYPE_CARTAO_AVENIDA = "Cartão Avenida"
export const TYPE_DEBITO = "Débito"
export const TYPE_CREDITO = "Crédito"

export const parseAmount = (amount: string): number =>
  parseFloat(amount.replace(/\./g, "").replace(",", ".")) || 0

export const isSoftway = (item: IDTEFPaymentItem): boolean =>
  item.authorization.toUpperCase() === SOFTWAY_AUTHORIZATION

export const isValidItem = (item: IDTEFPaymentItem): boolean => {
  const amount = parseAmount(item.total_amount)
  const brand = item.brand.toUpperCase().trim()
  return amount > 0 && !INVALID_BRANDS.includes(brand)
}

export const mapToCard = (item: IDTEFPaymentItem): ITefCard => ({
  bandeira: item.brand,
  redeAdquirente: item.authorization,
  quantidade: item.quantity,
  valorTotal: item.total_amount,
})
